@if (showToggleComponent) {
    <div class="flex align-items-center">
        <form [formGroup]="formName">
            <p-inputSwitch [ngClass]="{'booking': moduleName === 'booking'}" class="mt-2"
                [name]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
                [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
            ></p-inputSwitch>
        </form>
        <div class="flex-column ml-2">
            <div class="field-label">{{label}}</div>
            <div class="placeholder-text">{{placeholder}}</div>
        </div>
    </div>
}